<template>
  <BaseModal
    no-exit
    card-width="472px"
  >
    <template #toolbar>
      <div class="flex flex-col items-center justify-center w-full pt-1 gap-1 relative">
        <button
          class="absolute top-0 right-0 p-1.5"
          @click="handleClose"
        >
          <TagRemoveIcon stroke="#303546" />
        </button>
        <div class="flex items-center justify-center py-2 px-3">
          <img
            src="../../assets/images/chrome-icon.png"
            class="w-7 h-7 -mr-2"
            alt="Chrome Icon"
          >
          <svg
            width="29"
            height="28"
            viewBox="0 0 29 28"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0_11397_12648)">
              <circle
                cx="14.1111"
                cy="14"
                r="14"
                fill="#06070F"
                style="fill:#06070F;fill:color(display-p3 0.0235 0.0275 0.0588);fill-opacity:1;"
              />
              <path
                d="M10.1516 7.50717H11.2829V11.0487H7.88898V9.86816C7.88898 8.56372 8.9015 7.50717 10.1516 7.50717Z"
                fill="white"
                style="fill:white;fill-opacity:1;"
              />
              <path
                opacity="0.85"
                d="M16.9396 7.50714H12.4144V11.0486H16.9396V7.50714Z"
                fill="white"
                style="fill:white;fill-opacity:1;"
              />
              <path
                opacity="0.7"
                d="M16.3739 12.2291H12.4144V15.7706H15.2426C15.8674 15.7706 16.3739 15.2641 16.3739 14.6393V12.2291Z"
                fill="white"
                style="fill:white;fill-opacity:1;"
              />
              <path
                opacity="0.2"
                d="M20.3334 12.2291H17.5051V14.6393C17.5051 15.2641 18.0116 15.7706 18.6364 15.7706H20.3334V12.2291Z"
                fill="white"
                style="fill:white;fill-opacity:1;"
              />
              <path
                opacity="0.1"
                d="M16.9395 16.9514H20.3334V18.1319C20.3334 19.4363 19.3209 20.4928 18.0708 20.4928H16.9395V16.9514Z"
                fill="white"
                style="fill:white;fill-opacity:1;"
              />
              <path
                opacity="0.2"
                d="M14.677 16.9514H12.4144V20.4928H15.8083V18.0827C15.8083 17.4579 15.3018 16.9514 14.677 16.9514Z"
                fill="white"
                style="fill:white;fill-opacity:1;"
              />
              <path
                opacity="0.6"
                d="M18.0707 7.50714C19.3208 7.50714 20.3333 8.56369 20.3333 9.86813V11.0486H18.0707V7.50714Z"
                fill="white"
                style="fill:white;fill-opacity:1;"
              />
              <path
                opacity="0.85"
                d="M11.2829 12.2291H7.88898V15.7706H11.2829V12.2291Z"
                fill="white"
                style="fill:white;fill-opacity:1;"
              />
              <path
                opacity="0.6"
                d="M7.88898 16.9514H11.2829V20.4928H10.1516C8.9015 20.4928 7.88898 19.4363 7.88898 18.1319V16.9514Z"
                fill="white"
                style="fill:white;fill-opacity:1;"
              />
            </g>
            <defs>
              <clipPath id="clip0_11397_12648">
                <rect
                  width="28"
                  height="28"
                  fill="white"
                  style="fill:white;fill-opacity:1;"
                  transform="translate(0.111145)"
                />
              </clipPath>
            </defs>
          </svg>
        </div>
        <BaseText
          type="label"
          size="sm"
          class="text-text-muted text-center"
        >
          Authenticating Extension
        </BaseText>
        <BaseText
          type="body"
          size="sm"
          class="text-text-normal text-center max-w-xs"
        >
          We are connecting the Chrome Extension to your Foreplay account.
        </BaseText>
      </div>
    </template>

    <template #default>
      <div class="border-t border-b border-border-normal p-5">
        <!--  -->
        <button class="base-btn w-full flex items-center justify-center gap-1.5">
          <RefreshIcon
            v-if="loadingAuth || authState === AUTH_STATE.AUTHENTICATING"
            class="text-text-muted animate-spin"
            :width="16"
            :height="16"
          />
          <CheckmarkIcon
            v-else-if="authState === AUTH_STATE.AUTHENTICATED"
            class="text-secondary-green-100"
          />
          <BaseText
            type="label"
            size="sm"
            class="text-text-muted"
          >
            <span
              v-if="authState === AUTH_STATE.AUTHENTICATION_FAILED"
              class="text-secondary-red-100"
            >
              Failed to authenticate
            </span>
            <span v-else>
              {{ loadingAuth || authState === AUTH_STATE.AUTHENTICATING ? 'Authenticating' : 'Connected' }}
            </span>
          </BaseText>
        </button>
        <div class="mt-5">
          <BaseText
            type="label"
            size="sm"
            class="text-text-muted"
          >
            Return to
          </BaseText>
          <div class="flex flex-wrap gap-y-2 gap-x-4 w-full mt-1">
            <button
              v-for="path in RETURN_PATHS"
              :key="path.name"
              class="group hover:bg-background-normal rounded-md transition-colors py-1 px-2 w-52 flex justify-between items-center gap-1.5"
              @click="openPath(path.url)"
            >
              <div class="flex items-center gap-1.5">
                <component
                  :is="path.icon"
                  class="text-icon-normal w-5 h-5"
                />
                <BaseText
                  type="label"
                  size="sm"
                  class="text-text-muted"
                >
                  {{ path.name }}
                </BaseText>
              </div>
              <ExternalLinkIcon
                class="text-icon-normal w-5 h-5 opacity-0 group-hover:opacity-100 transition-opacity duration-100"
              />
            </button>
          </div>
        </div>
      </div>
      <div class="px-3.5 pt-3.5 flex items-center justify-between w-full">
        <BaseText
          size="sm"
          class="text-text-normal"
        >
          Having issues with the extension?
        </BaseText>
        <button
          class="flex items-center gap-1.5 pl-2 pr-2.5 py-1.5 rounded-md transition-colors duration-100 hover:bg-neutral-25"
          @click="showIntercom"
        >
          <ContactSupportIcon class="text-icon-normal" />
          <BaseText
            type="label"
            size="sm"
            class="text-text-muted"
          >
            Contact Support
          </BaseText>
        </button>
      </div>
    </template>
  </BaseModal>
</template>

<script>
import { mapGetters } from 'vuex'
import firebase from '@/api/config/FirebaseConfig'
// Icons
import RefreshIcon from '../globals/Icons/LensIcons/RefreshIcon.vue'
import CheckmarkIcon from '../globals/Icons/CheckmarkIcon.vue'
import ContactSupportIcon from '../globals/Icons/ContactSupportIcon.vue'
import MetaIcon from '../globals/Icons/FilterIcons/Platforms/MetaPlatformIcon.vue'
import InstagramIcon from '../globals/Icons/FilterIcons/Platforms/InstagramPlatformIcon.vue'
import YouTubeIcon from '../globals/Icons/FilterIcons/Platforms/YouTubePlatformIcon.vue'
import TikTokIcon from '../globals/Icons/FilterIcons/Platforms/TikTokPlatformIcon.vue'
import LinkedInIcon from '../globals/Icons/FilterIcons/Platforms/LinkedInPlatformIcon.vue'
import ExternalLinkIcon from '../globals/Icons/ExternalLinkIcon.vue'
import TagRemoveIcon from '../globals/Icons/TagRemoveIcon.vue'

export default {
  name: 'AuthExtModal',
  components: {
    RefreshIcon,
    CheckmarkIcon,
    ContactSupportIcon,
    MetaIcon,
    InstagramIcon,
    YouTubeIcon,
    TikTokIcon,
    LinkedInIcon,
    ExternalLinkIcon,
    TagRemoveIcon

  },
  data () {
    const RETURN_PATHS = [
      {
        icon: MetaIcon,
        name: 'Meta Ad Library',
        url: 'https://www.facebook.com/ads/library/?active_status=active&ad_type=all&country=ALL&is_targeted_country=false&media_type=all'
      },
      {
        icon: InstagramIcon,
        name: 'Instagram',
        url: 'https://www.instagram.com/'
      },
      {
        icon: YouTubeIcon,
        name: 'YouTube Shorts',
        url: 'https://www.youtube.com/shorts'
      },
      {
        icon: TikTokIcon,
        name: 'TikTok Ad Library',
        url: 'https://library.tiktok.com/ads'
      },
      {
        icon: LinkedInIcon,
        name: 'LinkedIn Ad Library',
        url: 'https://www.linkedin.com/ad-library/home'
      },
      {
        icon: TikTokIcon,
        name: 'TikTok',
        url: 'https://www.tiktok.com/'
      }
    ]

    const AUTH_STATE = {
      AUTHENTICATING: 'authenticating',
      AUTHENTICATED: 'authenticated',
      AUTHENTICATION_FAILED: 'authentication_failed'
    }
    return {
      RETURN_PATHS,
      AUTH_STATE,
      loadingAuth: true,
      authState: 'authenticating',
      pollAuth: null
    }
  },
  computed: {
    ...mapGetters('AuthModule', ['getUser'])
  },
  mounted () {
    this.initExtensionAuth()
    this.pollAuth = setInterval(() => {
      this.initExtensionAuth()
    }, 2000)
    setTimeout(() => {
      this.handleAuthTimeout()
    }, 10000)
  },
  methods: {
    handleClose () {
      this.$router.push({ name: 'LibraryView' })
    },
    async handleAuthTimeout () {
      clearInterval(this.pollAuth)
      if (this.authState === this.AUTH_STATE.AUTHENTICATED) return
      this.authState = this.AUTH_STATE.AUTHENTICATION_FAILED
      this.loadingAuth = false
      this.$showAlert({
        message: 'Failed to authenticate with the extension. Contact support.',
        type: 'error'
      })
    },
    async initExtensionAuth () {
      try {
        const currentUser = firebase.auth().currentUser

        const createTokenFunction = firebase
          .functions()
          .httpsCallable('createToken')

        const token = await createTokenFunction(currentUser.uid)

        console.log('Generating token', currentUser.uid)
        // eslint-disable-next-line no-undef
        chrome.runtime.sendMessage(
          'eaancnanphggbfliooildilcnjocggjm',
          // 'bbdonljpgkloakkdoddbkmddbiejiogn', // DEV Ext ID (NEVER USE THIS IN PROD)
          {
            event: 'auth',
            data: { token }
          },
          function (response) {
            if (response.status === 'worked') {
              this.authState = this.AUTH_STATE.AUTHENTICATED
              clearInterval(this.pollAuth)
              this.loadingAuth = false
              window.Intercom('update', {
                installed_extension: true
              })
              window.analytics.identify({
                extensionInstalled: true
              })
            } else {
              this.authState = this.AUTH_STATE.AUTHENTICATION_FAILED
              this.loadingAuth = false
              this.$showAlert({
                message: 'Failed to authenticate with the extension. Contact support.',
                type: 'error'
              })
            }
          }
        )

        // So this doesnt break for people witht he old ext
        try {
          // Also send this token to the plugin to authenticate the user
          const root = document.querySelector('#FP-PLUGIN')
          const iframe = root?.shadowRoot?.querySelector('.FP-plugin-iframe')
          if (iframe) {
            console.log('posting message')
            iframe.contentWindow.postMessage({
              source: 'fp:app',
              type: 'auth',
              data: { token }
            }, '*')
          }
          this.authState = this.AUTH_STATE.AUTHENTICATED
          clearInterval(this.pollAuth)
        } catch (error) {
          console.log(error)
          this.authState = this.AUTH_STATE.AUTHENTICATION_FAILED
          this.$showAlert({
            message: 'Failed to authenticate with the extension. Contact support.',
            type: 'error'
          })
        } finally {
          this.loadingAuth = false
        }
      } catch (error) {
        console.log('Error authenticating extension', error)
      }
    },
    showIntercom () {
      window.Intercom('show')
    },
    openPath (url) {
      window.open(url, '_blank')
    }
  }
}
</script>

<style scoped>
.base-btn {
  box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.13),
    0px 0px 0px 1px rgba(0, 56, 108, 0.08);
  transition: box-shadow 100ms ease-in-out, background-color 100ms ease-in-out;
  border-radius: 6px;
  padding: 6px 10px 6px 6px;
}

.base-btn:hover {
  box-shadow: 0px 1px 2px 0px rgba(4, 26, 75, 0.17),
    0px 0px 0px 1px rgba(0, 56, 108, 0.12);
}
</style>
